import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const TaillageHaie = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);
  return (
    <div className="page-container">
      <Helmet>
        <title>Tailler ses haies à Évry-Courcouronnes | Résultat net</title>
        <meta
          name="description"
          content="Besoin de tailler vos haies en Île-de-France ? Intervention rapide, coupe soignée et conseils adaptés à votre jardin. Devis gratuit."
        />
      </Helmet>
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Taille de haie</div>
          <h1 className="page-title">Taille de haie</h1>
        </div>

        {/* Main Image Section - Two Images Side by Side */}
        <section className="modern-section" style={{padding: '0 0 clamp(2rem, 4vw, 3rem) 0'}}>
          <div style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 clamp(1rem, 3vw, 1.8rem)'
          }}>
            {/* Left Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/Taillagedehaie/IMG_6257.webp" 
                alt="Taille de haie" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
            
            {/* Right Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/Taillagedehaie/IMG_6271.webp" 
                alt="Haie taillée" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
          </div>
        </section>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div className="modern-card" style={{maxWidth: '900px', margin: '0 auto'}}>
              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '1.25rem'}}>
                Une haie bien taillée, un jardin qui respire
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Une haie qui déborde, des branches irrégulières, une silhouette qui perd en harmonie… ça arrive vite. Pourtant, une taille bien faite change tout : votre jardin paraît plus net, plus lumineux, plus agréable à vivre.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Chez Call Garden, on ne se contente pas de couper. On redonne à vos haies une forme propre, durable, et adaptée à leur croissance.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Tailler une haie, ce n’est pas juste passer un outil. Chaque végétal a son rythme, sa densité, sa manière de repousser.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Nous intervenons dans toute l'Île-de-France, que vous soyez en maison individuelle, en résidence ou avec un grand terrain, nous nous adaptons à la configuration de votre jardin.
              </p>

              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginTop: '2.25rem', marginBottom: '1.25rem'}}>
                Pourquoi faire appel à Call Garden
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                On intervient avec une approche simple : faire du bon travail, proprement, et sans complications.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Concrètement, ça change quoi pour vous ?
              </p>
              <ul style={{margin: 0, paddingLeft: '1.25rem', marginBottom: '1.5rem'}}>
                <li>Une coupe nette et régulière, sans abîmer les branches.</li>
                <li>Un chantier propre, avec évacuation des déchets verts.</li>
                <li>Des conseils concrets pour entretenir votre haie entre deux passages.</li>
                <li>Garder un jardin soigné sans y passer des heures.</li>
                <li>Maîtriser la hauteur et l’épaisseur de leurs haies.</li>
                <li>Favoriser une croissance saine et dense.</li>
              </ul>

              <div style={{marginTop: '3rem', textAlign: 'center'}}>
                <Link to="/contact" className="modern-button">
                  <span>Demander un devis</span>
                  <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaillageHaie;
